<template>
<div>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-30 md-xsmall-size-100 md-size-30">
            <stats-card header-color="blue">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-money-check-alt"></i>
                    </div>
                    <h4 class="title">
                    LIMITE
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeCliente.limite || 'R$' }}
                    </div>
                </template>
            </stats-card>
        </div>
        <div class="md-layout-item md-medium-size-35 md-xsmall-size-100 md-size-35">
            <stats-card header-color="green">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-money-check-alt"></i>
                    </div>
                    <h4 class="title">
                    LIMITE DISPONÍVEL
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeCliente.limiteDsponivel || 'R$' }}
                    </div>
                </template>
            </stats-card>
        </div>
        <div class="md-layout-item md-medium-size-35 md-xsmall-size-100 md-size-35">
            <stats-card header-color="rose">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-money-check-alt"></i>
                    </div>
                    <h4 class="title">
                    LIMITE UTILIZADO
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeCliente.limiteUtilizado || 'R$' }}
                    </div>
                </template>
            </stats-card>
        </div>

        <div @click="faturas()" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
            <stats-card header-color="primary">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-file-invoice-dollar"></i>
                    </div>
                    <h4 class="title">
                    FATURAS
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        <span>Click para abrir</span>
                    </div>
                </template>
            </stats-card>
        </div>

        <div @click="fornecedores()" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
            <stats-card header-color="warning">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-store-alt"></i>
                    </div>
                    <h4 class="title">
                    LOJAS CREDENCIADA
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        <span>Click para abrir</span>
                    </div>
                </template>
            </stats-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    StatsCard,
    AnimatedNumber
} from "@/components";
import Notify from '@/config/mixins/notify'

export default {
    components: {
        StatsCard
    },

    data() {
        return {
            homeCliente: {},
            carregado: false
        };
    },

    created() {
        this.getHomeCliente();
    },

    mixins: [Notify],

    methods: {
        getHomeCliente() {
            this.$http.get(this.$urlAPI + 'home/cliente')
                .then(response => {
                    if(response.data.status){
                        this.homeCliente = response.data.dados
                        this.carregado = true
                    } else{
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        faturas() {
            if (this.carregado) {                
                this.$router.push({
                    name: 'pagamentosClienteRead',
                    params: {
                        id: this.homeCliente.cliente_id
                    }
                })
            }
        },

        fornecedores(){
            this.$router.push({
                name: 'fornecedoresRead'
            })
        }
    },
};
</script>
